import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * For autocomplete controls: empty or user typed but did not select an option
 */
export function objectValidator(control: AbstractControl): ValidationErrors | null {
    return !control.value || typeof control.value !== 'object'
        ? { invalidSelection: true }
        : null;
}
